// extracted by mini-css-extract-plugin
module.exports = {"timezoneNote":"channel-schedule_timezoneNote_2fSmh"};